import React, { useEffect, useRef, useState } from "react";
import { useHomeContext } from "@/context/homeContext";
import { useSearchParams } from "next/navigation";
import dynamic from "next/dynamic";
import RegionTitle from "./RegionTitle";

const RegionDropDownContent = dynamic(() => import("./RegionDropDownContent"), {
  ssr: false,
});

const RegionDropdown = ({ showAreas, setShowAreas, destinations }) => {
  const { setFilterForm } = useHomeContext();
  const searchParams = useSearchParams();
  const refOne = useRef(null);

  const [areas, setAreas] = useState([]);

  const handleShowAreas = () => {
    setShowAreas(!showAreas);
  };

  useEffect(() => {
    const bolge = searchParams.get("bolge");

    if (!bolge) return;

    const bolgeArray = bolge.split(",").map((item) => item.trim());
    const areaObject = bolgeArray.reduce((acc, value) => {
      acc[value] = true;
      return acc;
    }, {});

    setFilterForm((prev) => {
      const updated = {
        ...prev,
        bolge: bolgeArray,
      };
      return updated;
    });

    setAreas(areaObject);
  }, [searchParams]);

  return (
    <div
      ref={refOne}
      className="relative w-full mb-2 lg:w-1/4 xsm:w-1/2 lg:mb-0"
    >
      <RegionTitle handleShowAreas={handleShowAreas} areas={areas} />
      {showAreas && destinations?.length > 0 && (
        <RegionDropDownContent
          destinations={destinations}
          areas={areas}
          setAreas={setAreas}
          refOne={refOne}
          showAreas={showAreas}
          setShowAreas={setShowAreas}
        />
      )}
    </div>
  );
};

export default RegionDropdown;
